
(function(){
  var IDX=null, box=document.getElementById('q'), res=document.getElementById('results'), fullPanel=null;
  var RESULT_PREVIEW_COUNT=5;
  var STOP={
    a:1,an:1,and:1,are:1,as:1,at:1,be:1,can:1,cant:1,cannot:1,could:1,correctly:1,did:1,do:1,does:1,doesnt:1,dont:1,for:1,from:1,get:1,getting:1,has:1,have:1,help:1,how:1,i:1,in:1,is:1,isn:1,isnt:1,it:1,its:1,life:1,me:1,my:1,no:1,not:1,of:1,on:1,oontz:1,or:1,our:1,please:1,properly:1,speaker:1,speakers:1,t:1,the:1,this:1,to:1,what:1,when:1,where:1,which:1,why:1,will:1,with:1,won:1,wont:1,work:1,working:1,works:1,you:1,your:1
  };
  var SYN={
    batteries:'battery',buds:'budz',bt:'bluetooth',charged:'charge',charger:'charge',chargers:'charge',charges:'charge',charging:'charge',
    angel:'angle',angels:'angle',
    cable:'cable',cables:'cable',connec:'connect',cord:'cable',cords:'cable',dead:'power',
    connected:'connect',connecting:'connect',connection:'connect',connections:'connect',connects:'connect',
    factory:'reset',fourth:'4',hard:'reset',manuals:'manual',
    paired:'pair',pairing:'pair',pairs:'pair',
    reboot:'reset',rebooting:'reset',reboots:'reset',resets:'reset',resetting:'reset',restart:'reset',restarting:'reset',returns:'return',
    second:'2',third:'3',
    waterproofing:'waterproof',wet:'waterproof',water:'waterproof',
    wired:'aux',wireless:'bluetooth'
  };
  var SERVICE_ITEMS=[
    {k:'Service',p:'Warranty & Returns',h:'Warranty, returns, and exchanges',u:'/pages/warranty-1',b:'Every OontZ includes warranty support from Cambridge SoundWorks. For returns or warranty exchange help, contact OontZ with your order number, product model, and issue.'},
    {k:'Service',p:'Order Help',h:'Order status, shipping, and delivery help',u:'/pages/contact',b:'Need order status, tracking, delivery, shipping, address, invoice, or purchase help? Contact the OontZ team with your order number and email address.'},
    {k:'Service',p:'Parts & Accessories',h:'USB-C charging cable, replacement battery, mounts, brackets, and cases',u:'/collections/accessories',b:'Find USB Type-C charging cables, replacement batteries, brackets, mounts, cases, power adapters, and other OontZ accessories.'},
    {k:'Manual',p:'Product Manuals',h:'Find your product manual or quick-start guide',u:'/pages/help-center#cat-speakers',b:'Choose your OontZ product model to open the manual, quick-start guide, pairing steps, charging help, reset steps, and troubleshooting answers.'}
  ];
  if(!box) return;
  fetch(window.OONTZ_SEARCH_INDEX_URL||'assets/search-index.json').then(r=>r.json()).then(function(d){
    IDX=SERVICE_ITEMS.concat(d).map(prep);
    syncFromUrl();
  });
  function esc(s){return s.replace(/[&<>]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;'}[c]));}
  function norm(s){return (s||'').toLowerCase().replace(/[’‘]/g,"'").replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').trim();}
  function aliasPhrase(s){return s.replace(/\bangel\b/g,'angle').replace(/\bconnec\b/g,'connect').replace(/\btto\b/g,'to');}
  function canon(t){
    t=SYN[t]||t;
    t=t.replace(/^([0-9]+)(st|nd|rd|th)$/,'$1');
    if(t.length>5&&t.slice(-3)=='ies') t=t.slice(0,-3)+'y';
    if(t.length>4&&t.slice(-1)=='s'&&!/ss$/.test(t)) t=t.slice(0,-1);
    return SYN[t]||t;
  }
  function tokens(s,keepStop){
    var parts=norm(s).split(/\s+/).filter(Boolean), out=[], seen={};
    parts.forEach(function(part){
      var t=canon(part);
      if(!keepStop&&(STOP[t]||t.length<2)) return;
      if(!seen[t]){seen[t]=1;out.push(t);}
    });
    return out;
  }
  function tokenSet(list){var set={};list.forEach(function(t){set[t]=1;});return set;}
  function prep(it){
    var p=tokens(it.p,true), h=tokens(it.h,true), b=tokens(it.b,true);
    it._p=tokenSet(p);it._h=tokenSet(h);it._b=tokenSet(b);
    it._np=norm(it.p);it._nh=norm(it.h);it._nb=norm(it.b);
    return it;
  }
  function variants(t){
    var v=[t];
    if(t=='charge') v.push('charging','charged','charger');
    if(t=='cable') v.push('cord','usb','type c');
    if(t=='manual') v.push('guide','quick start');
    if(t=='pair') v.push('pairing','paired');
    if(t=='power') v.push('turn on','power on','powered');
    if(t=='connect') v.push('connecting','connected','connection');
    if(t=='return') v.push('returns','exchange');
    if(t=='reset') v.push('resetting');
    if(t=='waterproof') v.push('water resistant','ipx5','ipx6','ipx7');
    return v;
  }
  function addTerm(list,seen,t){t=canon(t);if(!STOP[t]&&!seen[t]){seen[t]=1;list.push(t);}}
  function expandTerms(phrase,terms){
    var seen={}, out=[];
    terms.forEach(function(t){addTerm(out,seen,t);});
    if(/\b(battery|playtime|play time)\b/.test(phrase)){addTerm(out,seen,'battery');addTerm(out,seen,'charge');}
    if(/\b(factory reset|hard reset|reboot|restart)\b/.test(phrase)) addTerm(out,seen,'reset');
    if(/\b(won t|wont|will not|does not|doesnt|not)\b.*\b(turn on|power on|power)\b|\b(dead|no power)\b/.test(phrase)){addTerm(out,seen,'power');addTerm(out,seen,'reset');addTerm(out,seen,'charge');}
    if(/\b(aux|auxiliary|wired|3 5mm|3 5 mm|headphone jack)\b/.test(phrase)){addTerm(out,seen,'aux');addTerm(out,seen,'connect');addTerm(out,seen,'cable');}
    else if(/\b(usb c|usb type c|type c|charging cable|charge cable|cable|cord)\b/.test(phrase)){addTerm(out,seen,'usb');addTerm(out,seen,'cable');addTerm(out,seen,'charge');}
    if(/\b(warranty|warranties|guarantee|return|returns|exchange)\b/.test(phrase)){addTerm(out,seen,'warranty');addTerm(out,seen,'return');}
    if(/\b(order|tracking|delivery|shipping|invoice)\b/.test(phrase)){addTerm(out,seen,'order');addTerm(out,seen,'shipping');}
    if(/\b(pool|shower|submerge|submerged|water resistant|waterproof|ipx5|ipx6|ipx7)\b/.test(phrase)) addTerm(out,seen,'waterproof');
    if(/\b(phone call|phone calls|speakerphone|hands free)\b/.test(phrase)){addTerm(out,seen,'phone');addTerm(out,seen,'call');addTerm(out,seen,'speakerphone');addTerm(out,seen,'mic');}
    return out;
  }
  function queryMeta(phrase){
    var m=phrase.match(/\bgen(?:eration)?\s*([1-9])\b/)||phrase.match(/\b([1-9])(?:st|nd|rd|th)\s+gen(?:eration)?\b/), model='';
    if(/\b3xl\b/.test(phrase)) model='3xl';
    else if(/\bsoundbar\b/.test(phrase)) model='soundbar';
    else if(/\badapter\b/.test(phrase)) model='adapter';
    else if(/\b(budz|bud|earbud|earbuds)\b/.test(phrase)&&/\bultra\b/.test(phrase)) model='budz-ultra';
    else if(/\b(budz|bud|earbud|earbuds)\b/.test(phrase)) model='budz';
    else if(/\bclip\b/.test(phrase)) model='clip';
    else if(/\bshower\b/.test(phrase)) model='shower';
    else if(/\braindance\b/.test(phrase)) model='raindance';
    else if(/\bsolo\b/.test(phrase)) model='solo';
    else if(/\bpro\b/.test(phrase)) model='pro';
    else if(/\bsup|paddle/.test(phrase)) model='sup';
    else if(/\bgolf|boat|clamp/.test(phrase)) model='golf';
    else if(/\bultra\b/.test(phrase)) model='ultra';
    else if(/\bangle 3\b/.test(phrase)) model='angle3';
    var service='';
    if(/\b(warranty|warranties|guarantee|return|returns|exchange)\b/.test(phrase)) service='warranty';
    else if(/\b(order|tracking|delivery|shipping|invoice)\b/.test(phrase)) service='order';
    else if(!/\b(aux|auxiliary|3 5mm|3 5 mm)\b/.test(phrase)&&/\b(replacement|accessor|accessories|parts|usb c|usb type c|type c|charging cable|charge cable|cable|cord|case)\b/.test(phrase)) service='parts';
    else if(/\b(manual|manuals|guide|quick start)\b/.test(phrase)) service='manual';
    return {gen:m?m[1]:'',model:model,service:service,issue:/\b(app|audio|battery|bluetooth|bracket|cable|call|charge|clamp|connect|firmware|mount|pair|power|remote|reset|siri|stereo|surround|usb|waterproof)\b/.test(phrase)};
  }
  function modelMatch(np,model){
    if(!model) return false;
    if(model=='angle3') return /\bangle 3\b/.test(np)&&!/\b(ultra|3xl|shower|raindance|pro)\b/.test(np);
    if(model=='ultra') return /\bangle 3 ultra\b/.test(np)&&!/\b(3xl|budz)\b/.test(np);
    if(model=='budz-ultra') return /\bbudz true wireless ultra\b/.test(np);
    if(model=='sup') return /\bsup\b|paddle/.test(np);
    if(model=='golf') return /\bgolf\b|\bh2o\b|\bboat\b|\bbracket\b/.test(np);
    return np.indexOf(model)>=0;
  }
  function hasKnownModel(np){return /\b(angle 3|3xl|soundbar|adapter|budz|clip|shower|raindance|solo|pro|sup|golf)\b/.test(np);}
  function genMatches(np,gen){return np.indexOf('gen '+gen)>=0||np.indexOf(gen+' generation')>=0;}
  var ISSUE={app:1,audio:1,aux:1,battery:1,bluetooth:1,bracket:1,cable:1,call:1,charge:1,clamp:1,connect:1,firmware:1,mount:1,pair:1,power:1,remote:1,reset:1,siri:1,stereo:1,surround:1,usb:1,waterproof:1};
  function mark(t,q,terms){
    var direct=norm(q), low=t.toLowerCase(), i=direct.length>2?low.indexOf(direct):-1, len=direct.length;
    if(i<0){
      var all=[];
      terms.forEach(function(term){all=all.concat(variants(term));});
      for(var n=0;n<all.length;n++){i=low.indexOf(all[n]);if(i>=0){len=all[n].length;break;}}
    }
    if(i<0)return esc(t.slice(0,160));
    var s=Math.max(0,i-48);
    return (s>0?'…':'')+esc(t.slice(s,i))+'<mark>'+esc(t.slice(i,i+len))+'</mark>'+esc(t.slice(i+len,i+len+92))+'…';
  }
  function score(it,phrase,terms,meta){
    var score=0, matched=0;
    if(phrase.length>2){
      if(it._nh.indexOf(phrase)>=0) score+=80;
      if(it._np.indexOf(phrase)>=0) score+=70;
      if(it._nb.indexOf(phrase)>=0) score+=28;
    }
    terms.forEach(function(t){
      var hit=false;
      if(it._p[t]){score+=24;hit=true;}
      if(it._h[t]){score+=18;hit=true;}
      if(it._b[t]){score+=6;hit=true;}
      if(!hit&&it._np.indexOf(t)>=0){score+=8;hit=true;}
      if(!hit&&it._nh.indexOf(t)>=0){score+=6;hit=true;}
      if(!hit&&it._nb.indexOf(t)>=0){score+=2;hit=true;}
      if(hit) matched++;
    });
    if(!matched) return 0;
    if(terms.length>1&&matched<Math.min(terms.length,2)) return 0;
    score+=matched/Math.max(terms.length,1)*20;
    if(meta.issueTerms&&meta.issueTerms.length){
      var issueAny=false, issueStrong=false;
      meta.issueTerms.forEach(function(t){
        if(it._h[t]||it._nh.indexOf(t)>=0){score+=42;issueAny=true;issueStrong=true;}
        else if(it._p[t]||it._b[t]||it._np.indexOf(t)>=0||it._nb.indexOf(t)>=0){score+=10;issueAny=true;}
      });
      if(!issueAny&&it.k!='Service'&&it.k!='Manual') score-=28;
      if(it.k=='Article'&&!issueStrong) score-=22;
    }
    if(/\bbluetooth\b/.test(phrase)&&!/\b(aux|auxiliary|wired|non bluetooth|3 5)\b/.test(phrase)&&/\b(aux|aux in|non bluetooth|wired|3 5mm|3 5 mm)\b/.test(it._nh+' '+it._nb)) score-=44;
    if(meta.model){
      if(modelMatch(it._np,meta.model)) score+=40;
      else if(hasKnownModel(it._np)) score-=32;
    }
    if(meta.gen){
      if(genMatches(it._np,meta.gen)) score+=34;
      else if(/\bgen [1-9]\b/.test(it._np)) score-=30;
    }
    if(it.k=='FAQ') score+=meta.issue?26:14;
    if(it.k=='Article'&&meta.issue) score-=34;
    if(it.k=='Service'){
      if(/\baux|auxiliary|3 5mm|3 5 mm\b/.test(phrase)) score-=90;
      if(meta.model&&meta.service!='warranty'&&meta.service!='order') score-=38;
      if(meta.service=='warranty'&&/\b(warranty|return|exchange)\b/.test(it._np+' '+it._nh)) score+=76;
      else if(meta.service=='order'&&/\b(order|shipping|delivery|tracking|invoice)\b/.test(it._np+' '+it._nh)) score+=76;
      else if(meta.service=='parts'&&/\b(parts|accessories|cable|battery|mounts|brackets|cases)\b/.test(it._np+' '+it._nh)) score+=76;
      else score-=48;
    }
    if(it.k=='Manual') score+=meta.service=='manual'?72:0;
    return Math.max(0,score);
  }
  function resultCard(x,q,terms){
    var it=x[1];
    return '<a class="res" href="'+it.u+'"><span class="rk">'+it.k+' · '+esc(it.p)+'</span><div class="rt">'+esc(it.h)+'</div><div class="rs">'+mark(it.b,q,terms)+'</div></a>';
  }
  function searchUrl(q){return window.location.pathname+'?support_search='+encodeURIComponent(q)+'#support-search-results';}
  function modelLabel(model){
    return ({
      angle3:'OontZ Angle 3',
      ultra:'OontZ Angle 3 Ultra',
      'budz-ultra':'OontZ BudZ True Wireless Ultra',
      budz:'OontZ BudZ',
      clip:'OontZ Clip',
      shower:'OontZ Shower',
      raindance:'OontZ RainDance',
      solo:'OontZ Solo',
      pro:'OontZ Pro',
      soundbar:'OontZ Soundbar',
      adapter:'OontZ Bluetooth Adapter',
      '3xl':'OontZ Angle 3XL / 3XL Ultra',
      sup:'SUP mount',
      golf:'Golf & H2O mount'
    })[model]||'selected model';
  }
  function renderResults(hits,q,terms){
    var visible=hits.slice(0,RESULT_PREVIEW_COUNT), html=visible.map(function(x){return resultCard(x,q,terms);}).join('');
    if(hits.length>RESULT_PREVIEW_COUNT){
      html+='<a class="res-more" href="'+searchUrl(q)+'" data-search-full>View all '+hits.length+' results</a>';
    }
    res.innerHTML=html;
    res.classList.add('open');
  }
  function ensureFullPanel(){
    if(fullPanel) return fullPanel;
    fullPanel=document.createElement('section');
    fullPanel.id='support-search-results';
    fullPanel.className='support-results-page';
    fullPanel.hidden=true;
    fullPanel.innerHTML='<div class="wrap"><div class="support-results-page__head"><div><p class="support-results-page__eyebrow">Search results</p><h2></h2><p class="support-results-page__meta"></p></div><a class="support-results-page__clear" href="'+window.location.pathname+'">Clear search</a></div><div class="support-results-page__list"></div></div>';
    var hero=document.querySelector('.hero');
    if(hero&&hero.parentNode) hero.parentNode.insertBefore(fullPanel,hero.nextSibling);
    return fullPanel;
  }
  function clearFullPanel(){
    if(fullPanel) fullPanel.hidden=true;
  }
  function getData(q){
    if(!IDX||!q.trim()) return null;
    var phrase=aliasPhrase(norm(q)), terms=expandTerms(phrase,tokens(phrase,false)), meta=queryMeta(phrase), hits=[];
    meta.issueTerms=terms.filter(function(t){return ISSUE[t];});
    if(!terms.length) return {q:q,phrase:phrase,terms:terms,meta:meta,hits:[],emptyTerms:true};
    for(var i=0;i<IDX.length;i++){var it=IDX[i], s=score(it,phrase,terms,meta);if(s>0) hits.push([s,it]);}
    if(meta.model) hits=hits.filter(function(x){return modelMatch(x[1]._np,meta.model);});
    if(meta.gen) hits=hits.filter(function(x){return !/\bgen [1-9]\b/.test(x[1]._np)||genMatches(x[1]._np,meta.gen);});
    hits.sort((a,b)=>b[0]-a[0]||a[1].p.localeCompare(b[1].p));
    return {q:q,phrase:phrase,terms:terms,meta:meta,hits:hits,emptyTerms:false};
  }
  function renderNoResults(message){
    res.innerHTML='<div class="nores">'+message+'</div>';
    res.classList.add('open');
  }
  function renderFullPage(data){
    var panel=ensureFullPanel(), title=panel.querySelector('h2'), meta=panel.querySelector('.support-results-page__meta'), list=panel.querySelector('.support-results-page__list');
    var label=data.meta.model?modelLabel(data.meta.model):'';
    title.textContent=data.hits.length+' result'+(data.hits.length==1?'':'s')+' for "'+data.q+'"';
    meta.textContent=label?'Showing only results under '+label+'.':'Showing every matching guide and answer.';
    list.innerHTML=data.hits.length?data.hits.map(function(x){return resultCard(x,data.q,data.terms);}).join(''):'<div class="nores">No results under '+(label||'that model')+'. Try a shorter issue, like "pairing", "charging", or "reset".</div>';
    panel.hidden=false;
  }
  function run(q,mode){
    if(!IDX||!q.trim()){res.classList.remove('open');res.innerHTML='';clearFullPanel();return;}
    var data=getData(q);
    if(!data) return;
    if(data.emptyTerms){renderNoResults('Try a product name plus the issue, like "Solo charging" or "Angle 3 pairing".');return;}
    if(mode=='page'){
      res.classList.remove('open');
      renderFullPage(data);
      return;
    }
    clearFullPanel();
    if(!data.hits.length){
      renderNoResults(data.meta.model?'No results under '+modelLabel(data.meta.model)+'. Try "pairing", "charging", "reset", or a shorter issue.':'No results. Try "pairing", "charging", "reset", or a product name.');
      return;
    }
    renderResults(data.hits,q,data.terms);
  }
  function openFullSearch(q,replace){
    if(!q.trim()) return;
    box.value=q;
    run(q,'page');
    if(replace) history.replaceState(null,'',searchUrl(q));
    else history.pushState(null,'',searchUrl(q));
    var panel=ensureFullPanel();
    panel.scrollIntoView({behavior:'smooth',block:'start'});
  }
  function syncFromUrl(){
    var params=new URLSearchParams(window.location.search);
    var full=params.get('support_search');
    var initial=full||params.get('q');
    if(initial){
      box.value=initial;
      run(initial,full?'page':'preview');
      if(full&&window.location.hash=='#support-search-results') setTimeout(function(){ensureFullPanel().scrollIntoView({block:'start'});},0);
    }else{
      res.classList.remove('open');
      res.innerHTML='';
      clearFullPanel();
    }
  }
  box.addEventListener('input',e=>run(e.target.value));
  box.addEventListener('focus',e=>{if(box.value)run(box.value);});
  res.addEventListener('click',function(e){
    var btn=e.target.closest('[data-search-full]');
    if(!btn) return;
    e.preventDefault();
    openFullSearch(box.value,false);
  });
  document.querySelectorAll('[data-query]').forEach(function(link){
    link.addEventListener('click',function(e){
      e.preventDefault();
      var q=link.getAttribute('data-query')||'';
      box.value=q;
      box.focus();
      run(q);
      history.replaceState(null,'','?q='+encodeURIComponent(q));
    });
  });
  document.addEventListener('click',e=>{if(!res.contains(e.target)&&e.target!==box)res.classList.remove('open');});
  box.addEventListener('keydown',function(e){
    if(e.key=='Escape') res.classList.remove('open');
    if(e.key=='Enter'&&box.value.trim()){
      e.preventDefault();
      openFullSearch(box.value,false);
    }
  });
  window.addEventListener('popstate',syncFromUrl);
})();
